"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIconCache = exports.IconProvider = exports.IconContext = exports.DEFAULT_PRECACHED_ICONS = void 0;
const react_1 = __importDefault(require("react"));
const _1 = require(".");
const IconImports_1 = require("./IconImports");
exports.DEFAULT_PRECACHED_ICONS = [
    "arrow-down",
    "arrow-left",
    "arrow-right",
    "arrow-up",
    "caret-down",
    "caret-left",
    "caret-right",
    "caret-up",
    "check",
    "check-circle",
    "info",
    "link",
    "magnifying-glass",
    "share-fat",
    "warning-octagon",
    "x-circle",
    "x"
];
const PreCachedIcons = ({ icons }) => {
    // precaching icons avoids flickering when icons are loaded for the first time
    return (react_1.default.createElement("div", { style: { display: "none" } }, icons.map((icon) => (react_1.default.createElement(_1.Icon, { key: "precached-" + icon, icon: icon })))));
};
const defaultContext = {
    cacheIconComponent: () => () => null,
    getIconComponent: () => () => null,
    iconCacheRef: new Map()
};
exports.IconContext = react_1.default.createContext(Object.assign({}, defaultContext));
const IconProvider = ({ preCacheIcons, children }) => {
    const iconCacheRef = react_1.default.useRef(new Map());
    const mergedPreCacheIcons = react_1.default.useMemo(() => {
        return Array.from(new Set([...exports.DEFAULT_PRECACHED_ICONS, ...preCacheIcons]));
    }, [preCacheIcons]);
    const getIconComponent = react_1.default.useCallback((iconName) => {
        if (iconCacheRef.current.has(iconName)) {
            return iconCacheRef.current.get(iconName);
        }
        const LazyComponent = (0, IconImports_1.loadIcon)(iconName);
        const IconComponent = (props) => (react_1.default.createElement(react_1.default.Suspense, null,
            react_1.default.createElement(LazyComponent, Object.assign({}, props))));
        IconComponent.displayName = iconName;
        return IconComponent;
    }, []);
    const cacheIconComponent = react_1.default.useCallback((iconName, LazyComponent) => {
        if (!iconCacheRef.current.has(iconName)) {
            iconCacheRef.current.set(iconName, LazyComponent);
        }
    }, []);
    const contextValue = react_1.default.useMemo(() => ({
        getIconComponent,
        cacheIconComponent,
        iconCacheRef: iconCacheRef.current
    }), [getIconComponent, cacheIconComponent]);
    return (react_1.default.createElement(exports.IconContext.Provider, { value: contextValue },
        react_1.default.createElement(PreCachedIcons, { icons: mergedPreCacheIcons }),
        children));
};
exports.IconProvider = IconProvider;
const useIconCache = () => {
    const context = react_1.default.useContext(exports.IconContext);
    if (!context) {
        throw new Error("useIconCache must be used within an IconCacheProvider");
    }
    return context;
};
exports.useIconCache = useIconCache;
//# sourceMappingURL=IconContext.js.map